import { useCallback } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';
import { useAuth0 } from '../context/auth0';

// TODO: maybe should be called useFileApi
export function useUploadFile(targetId, purpose, actionToken) {
  const { token } = useAuth0();
  const authorizationHeader = token
    ? { Authorization: `Bearer ${token}` }
    : { 'Action-Token-Authorization': actionToken };

  const uploadFile = useCallback(
    async (file) => {
      const formData = new FormData();
      formData.append('id', targetId);
      formData.append('purpose', purpose);
      formData.append('resource', file);

      return await axios.post(`${endpoints.core}/files`, formData, {
        headers: {
          ...authorizationHeader,
          'content-type': 'multipart/form-uploadResponseData',
        },
      });
    },
    [targetId, purpose, authorizationHeader]
  );

  const deleteFile = useCallback(
    async (resourceId) => {
      return await axios.delete(`${endpoints.core}/files/${resourceId}`, {
        headers: {
          ...authorizationHeader,
          'content-type': 'multipart/form-uploadResponseData',
        },
      });
    },
    [authorizationHeader]
  );

  return { uploadFile, deleteFile };
}
